module.exports = __webpack_public_path__ + "static/media/AdaBotHead.8cfadb42.png";